import APIService from "./APIService";

const http = APIService.http;

export default {
  async getRedirectURL(redirect) {
    let res = await http.post(`api/redirect/redirectAndLog`, redirect, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return res.data;
  },
  async getRedirectURLNoLog(redirect) {
    let res = await http.post(`api/redirect/redirect`, redirect, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return res.data;
  },
};
